var map = {
	"./dog-gif.png": "7a14",
	"./dog-grooming.png": "82b6",
	"./dog-sitters.png": "39c0",
	"./dog-walkers.png": "5312",
	"./doggies-gif.png": "e501",
	"./ellipse-gif.png": "c0d9",
	"./forbes.png": "c4c6",
	"./getAppleStore.png": "09cf",
	"./getPlaystore.png": "cad2",
	"./hero-bg.png": "3b81",
	"./hero-bgg.png": "cd81",
	"./kassim.png": "0eba",
	"./logo.png": "9d64",
	"./phone.png": "1e37",
	"./techradar.png": "13f5",
	"./theguardian.png": "4e8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";